import ADMIN from "./ADMIN";
import OBSERVER from "./OBSERVER";
import PM from "./PM";
import MEMBER from "./MEMBER";

export default { ADMIN, OBSERVER, PM, MEMBER };
